import {  } from '../../../../../../../Components/FinalTable';

import TableHeader from '../../../../../../../Components/FinalTable/components/TableHeader';

import HeaderBtnSort from '../../../../../../../Components/FinalTable/components/Btns/HeaderBtnSort';

const Headertbl =({Titles})=>{
    return (
        <div>
            <TableHeader h={2} mt={10}>
                { Titles.map((title)=>(
                       <HeaderBtnSort
                       click={function noRefCheck(){}}
                       label={title.name}
                       w={100/3}
                   />
                ))
                }
            </TableHeader>
        </div>
    )
}
export default Headertbl;